import { TokenConsumptionCompactBar } from './TokenConsumptionBar';
import { TokensCountTooltip } from './TokensCountTooltip';
import { needShowWarning } from './utils';
import { classNames } from '~/utils/classNames';
import { formatTokens } from '~/utils/format';

/**
 * TODO: need changes after backend fix.
 * https://linear.app/stackblitz/issue/BAC-145/extend-member-data-or-create-new-endpoint-to-fetch-member-info.
 */

/**
 * TokenUsageBadge component displays the token usage information in a compact format.
 * It shows the current token balance and a compact bar for visual representation.
 */
export interface TokenUsageBadgeProps {
  tokens: {
    total: number;
    left: number;
  };
  className?: string;
  period?: 'monthly' | 'daily';
  purchasedTokens?: number;
  referralTokens?: number;
  specialTokens?: number;
}

export const TokenUsageBadge = ({
  tokens,
  purchasedTokens = 0,
  referralTokens = 0,
  specialTokens = 0,
  period = 'monthly',
  className,
}: TokenUsageBadgeProps) => {
  const extraTokens = purchasedTokens + referralTokens + specialTokens;
  const usedTokens = tokens.total - tokens.left;
  const showWarning = needShowWarning(tokens.total, usedTokens);

  return (
    <div className={classNames('flex flex-col gap-2', className)}>
      <div className="flex flex-wrap items-center gap-1 font-semibold text-sm">
        {extraTokens > 0 && (
          <>
            <TokensCountTooltip
              referralTokens={referralTokens}
              specialTokens={specialTokens}
              purchasedTokens={purchasedTokens}
            >
              <span className="text-bolt-ds-success">{formatTokens(extraTokens)} extra</span>
            </TokensCountTooltip>

            <span>+</span>
          </>
        )}

        {showWarning && <span className="inline-block i-ph:bell-ringing-bold text-bolt-ds-warning" />}

        <span className={classNames(showWarning ? 'text-bolt-ds-warning' : 'text-bolt-ds-brand')}>
          {formatTokens(tokens.left)} / {formatTokens(tokens.total)} {period}
        </span>
      </div>

      <TokenConsumptionCompactBar extraTokens={extraTokens} tokens={tokens} warning={showWarning} />
    </div>
  );
};
